import { render, staticRenderFns } from "./CardDate.vue?vue&type=template&id=6f95f133&scoped=true"
import script from "./CardDate.vue?vue&type=script&lang=js"
export * from "./CardDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95f133",
  null
  
)

export default component.exports